import { Box, FormControl, FormHelperText, InputLabel, MenuItem, Select, Typography } from "@mui/material";
import { MachineCentersEntity } from "entities/MachineCenters/MachineCentersEntity";
import { useStyles } from "../MachineCenterCreationForm.styles";
import type { IMachineCenterCreationFormValues } from "../MachineCenterCreationFormInterfaces";

interface PerformanceTabProps {
    values: IMachineCenterCreationFormValues;
    errors: Record<string, unknown>;
    touched: Record<string, unknown>;
    setFieldValue: (field: string, value: unknown) => void;
    t: (key: string) => string;
    isMillAspenPlusEnabled: boolean;
}

export const PerformanceTab = ({
    values,
    errors,
    touched,
    setFieldValue,
    t,
    isMillAspenPlusEnabled,
}: PerformanceTabProps) => {
    const classes = useStyles();
    const { oeeInputMethodOptions, loading } = MachineCentersEntity.GetOeeInputMethods();
    const disabled = !isMillAspenPlusEnabled || !values.aspen_plus_oee_enabled;

    return (
        <Box className={classes.tabPanel}>
            <Box className={classes.boxContainer}>
                <InputLabel id="oee-input-method-label">
                    <Typography variant="subtitle2" className={classes.formLabel}>
                        {t("corporate_backoffice.production_line_view.machine_center_creation_form.oee_input_method")}
                    </Typography>
                </InputLabel>
                <FormControl
                    error={Boolean(touched.oee_input_method_id && errors.oee_input_method_id)}
                    className={classes.textField}
                    fullWidth
                    disabled={disabled || loading}
                >
                    <Select
                        labelId="oee-input-method-label"
                        id="oee-input-method-select"
                        className={classes.select}
                        name="oee_input_method_id"
                        value={values.oee_input_method_id === "" ? "" : values.oee_input_method_id}
                        onChange={(e) =>
                            setFieldValue("oee_input_method_id", e.target.value === "" ? "" : Number(e.target.value))
                        }
                        displayEmpty
                    >
                        {oeeInputMethodOptions.map((opt) => (
                            <MenuItem key={opt.id} value={opt.id}>
                                {opt.name}
                            </MenuItem>
                        ))}
                    </Select>
                    <FormHelperText>
                        {touched.oee_input_method_id && errors.oee_input_method_id
                            ? t(String(errors.oee_input_method_id))
                            : null}
                    </FormHelperText>
                </FormControl>
            </Box>
        </Box>
    );
};
